import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: localStorage.getItem('isAuthenticated') === 'true',
  email: "",
  socket: null,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload
    },

    auth: (state, action) => {
      localStorage.setItem('isAuthenticated', action.payload ? 'true' : 'false');
      state.isAuth = action.payload
    },

    resetAuth: (state) => {
      localStorage.removeItem('isAuthenticated');
      state.isAuth = false;
      state.email = "";
      state.socket = null;
    }
  },
});

export const { setEmail, auth, resetAuth } = authSlice.actions;
export default authSlice.reducer